const { createAction } = require("../helpers");
const {
  CREATE_KYC_USER,
  CREATE_KYC_USER_SUCCESS,
  CREATE_KYC_USER_RESET,
  CREATE_KYC_USER_ERROR,

  GET_KYC_USER,
  GET_KYC_USER_SUCCESS,
  GET_KYC_USER_ERROR,
  GET_KYC_USER_RESET,

  UPDATE_KYC_USER,
  UPDATE_KYC_USER_SUCCESS,
  UPDATE_KYC_USER_RESET,
  UPDATE_KYC_USER_ERROR,
} = require("./constants");

const createKycUser = ({
  userId,
  type,
  icBack,
  icFront,
  passportImage,
  profileImage,
  name,
  number,
}) =>
  createAction(CREATE_KYC_USER, {
    userId,
    type,
    icBack,
    icFront,
    passportImage,
    profileImage,
    name,
    number,
  });

const createKycUserSuccess = (data) =>
  createAction(CREATE_KYC_USER_SUCCESS, { data });

const createKycUserError = (error) =>
  createAction(CREATE_KYC_USER_ERROR, { error });

const createKycUserReset = () => createAction(CREATE_KYC_USER_RESET);

const getKycUser = () => createAction(GET_KYC_USER);

const getKycUserSuccess = (data) =>
  createAction(GET_KYC_USER_SUCCESS, { data });

const getKycUserError = (error) => createAction(GET_KYC_USER_ERROR, { error });

const getKycUserReset = () => createAction(GET_KYC_USER_RESET);

const updateKycUser = ({
  userId,
  type,
  icBack,
  icFront,
  passportImage,
  profileImage,
  name,
  number,
}) =>
  createAction(UPDATE_KYC_USER, {
    userId,
    type,
    icBack,
    icFront,
    passportImage,
    profileImage,
    name,
    number,
  });

const updateKycUserSuccess = (data) =>
  createAction(UPDATE_KYC_USER_SUCCESS, { data });

const updateKycUserError = (error) =>
  createAction(UPDATE_KYC_USER_ERROR, { error });

const updateKycUserReset = () => createAction(UPDATE_KYC_USER_RESET);

module.exports = {
  createKycUser,
  createKycUserSuccess,
  createKycUserError,
  createKycUserReset,

  getKycUser,
  getKycUserSuccess,
  getKycUserError,
  getKycUserReset,

  updateKycUser,
  updateKycUserSuccess,
  updateKycUserError,
  updateKycUserReset,
};
